import { BaseState } from '@/store/base-state';
import { AlfaApiLoanApplications } from '../types';

export default class AlfaApiLoanApplicationsState extends BaseState {
  alfaApiLoanApplications: AlfaApiLoanApplications.AlfaApiLoanApplication[] = [];
  alfaApiLoanApplicationsLoading = false;

  filters: AlfaApiLoanApplications.AlfaApiLoanApplicationIndexFilters = {
    organizationIds: [],
    statusIds: [],
    orderIds: [],
    createdDateRange: [],
    orderDateRange: [],
  };
}
